function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#1565C0",
  d: "M8.905 5.049h.003c.068-.287.314-.499.621-.499h8.757c.01 0 .022-.005.033-.004C18.132 1.44 15.527 0 13.228 0H4.47c-.308 0-.554.218-.621.505L3.847.504.019 18.078l.008.001c-.009.042-.025.081-.025.126 0 .36.29.644.65.644h5.246l3.007-13.8z"
}), React.createElement("path", {
  fill: "#039BE5",
  d: "M18.319 4.546c.034.57-.003 1.189-.149 1.873-.833 3.897-3.843 5.925-7.563 5.925H7.804c-.339 0-.499.199-.572.351L6.1 17.927l-.198.929h-.004l-.821 3.767h.008c-.009.043-.025.082-.025.127 0 .36.29.65.65.65h4.766l.009-.006c.307-.005.55-.224.614-.513l.012-.01 1.178-5.47s.081-.522.63-.522h2.716c3.72 0 6.76-2.019 7.594-5.916.937-4.394-2.197-6.4-4.911-6.417z"
}), React.createElement("path", {
  fill: "#283593",
  d: "M9.529 4.55c-.308 0-.554.212-.62.5l-.004-.001-1.674 7.647c.074-.152.234-.351.572-.351h2.753c3.72 0 6.78-2.028 7.613-5.925.147-.684.184-1.304.15-1.873-.011-.002-.023.003-.033.003H9.529z"
}));

var SvgIconPaypal = function SvgIconPaypal(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconPaypal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-paypal.c4dd7df9.svg";
export { ForwardRef as ReactComponent };